import { takeLatest } from 'redux-saga/effects';
import { handleGetBankBranches, handleGetBanks, handleSaveBankAccountDetails } from './bankDetailsFormHandlers';
import { getBankBranches, getBanks, saveBankAccountDetails } from './bankDetailsFormSlice';

export function* getBanksSaga() {
  yield takeLatest(getBanks.type, handleGetBanks);
}

export function* getBankBranchesSaga() {
  yield takeLatest(getBankBranches.type, handleGetBankBranches);
}

export function* saveBankAccountDetailsSaga() {
  yield takeLatest(saveBankAccountDetails.type, handleSaveBankAccountDetails);
}
